

/*
* 日期格式化
*/
export function dateFormat (date, fmt) {
  // 'yyyy-MM-dd hh:mm:ss'   2019-05-05 19:01:02 不要大写HH
  
  if (!date) return '';  
  
  fmt = fmt || 'yyyy-MM-dd'
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

/**
 * 合并两个json对象属性为一个对象
 */
export function merge(oldConfig, newConfig) {
    let mergeConfig = clone(oldConfig);
    if (!newConfig || !Object.keys(newConfig).length) return mergeConfig;
    for (let key in newConfig) {
      if (key !== 'header') {
        mergeConfig[key] = newConfig[key];
      } else {
        if (Object.prototype.toString.call(newConfig[key]) === '[object Object]') {
          for (let headerKey in newConfig[key]) {
            mergeConfig[key][headerKey] = newConfig[key][headerKey];
          }          
        }
      }
    }
    return mergeConfig;
  }
  
/**
 * 深copy对象
 */
export function clone(obj) {
    let result = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object') {
          result[key] = clone(obj[key]);
        } else {
          result[key] = obj[key];
        }
      }
    }
    return result;
  }
  
/**
* 手机号码校验
* @param {*} s
*/
export function isMobile (s) {
  return /^1\d{10}$/.test(s)
}

/*
* 接送机订单状态字典
* */
export function orderStateDict(){
	return [
		{code: 0, name: '等待司机接单（刷新可查看最新状态）'},
		{code: 1, name: '司机抢单中（刷新可查看最新状态）'},
		{code: 2, name: '司机已接单（刷新可查看最新状态）'},
		{code: 3, name: '司机接客中（刷新可查看最新状态）'},
		{code: 4, name: '乘客已上车（刷新可查看最新状态）'},
		{code: 5, name: '已完成'},
		{code: 6, name: '乘客已取消'},
		{code: 7, name: '无效订单'},
		{code: 8, name: '用车服务已取消'},
		{code: 9, name: '接送过程中异常订单'},
	]
}

/**
 * 根据code寻找name
 * @param arr 字典数组  code 目标code
 */
export function nameByCode(code,arr) {
  if (!code && code != 0) {return ''}

  for(let i in arr) {
    if (arr[i].code == code) {
      return arr[i].name
    }
  }
  return code
}

export function udid(){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});
}

export function findCurModule(target) {
  let path = target.$router.history.current.path || "";
  let find = target.source.moduleTree.find(item => {
    return item.targetUrl == path;
  });
  return find;
}

var agent = navigator.userAgent.toLowerCase();
const isAndroid = agent.indexOf("android") != -1;
const isIOS = agent.indexOf("iphone") != -1;

module.exports = {
	dateFormat,
	merge,
	clone,
	isMobile,
	orderStateDict,
  udid,
  findCurModule,
	nameByCode,
    isAndroid,
    isIOS,
    isPhone: isAndroid || isIOS
}



// WEBPACK FOOTER //
// ./src/common/util.js